import axios from 'axios'
const BASE_API = 'https://viacep.com.br/ws/'

export default {
  get (zipcode) {
    return axios.get(`${BASE_API}/${zipcode}/json`)
  }
}
